<template>
  <div class="body splash">
    <img class="icon" src="../assets/img/bg.png">
    <img class="logo" src="../assets/img/asahi_logo-en.png">
  </div>
</template>

<script>
export default {
  name: 'splash',
  data: () => {
    return {
      hoge: 'fuga'
    }
  },
  mounted: () => {
    setTimeout(() => {
      window.location.href = '/top';
    }, 2400);
  }
}
</script>

<style scoped lang="scss">
.splash {
  display: flex;
  justify-content: center;

  opacity: 0;
  animation: splash 1.5s ease 0.2s 1 forwards;

}
@keyframes splash {
  100% {
    opacity: 1;
  }
}

.icon {
  position: fixed;
  top: 20vh;
  width: 120%;
  max-width: 464px;
}
.logo {
  position: fixed;
  bottom: 16px;
  width: 60%;
  max-width: 240px;
}
</style>


// WEBPACK FOOTER //
// src/components/splash.vue